import { Container, Flex } from "theme-ui";
import { AccordionButton, AccordionProps } from "./AccordionButton";

export interface AccordionSectionProps {
  faqQuestions: AccordionProps[];
  className?: string;
}

export const AccordionSection: React.FC<AccordionSectionProps> = (
  props: AccordionSectionProps
) => {
  const { faqQuestions, className } = props;

  return (
    <Container
      sx={{
        width: "100%",
        maxWidth: "757px",
        px: "20px",
        py: 0,
        pb: 3,
      }}
    >
      <Flex
        role="tablist"
        sx={{
          flexDirection: "column",
          rowGap: "20px",
        }}
      >
        {faqQuestions.map((faq, i) => (
          <div
            data-sal="slide-right"
            data-sal-delay={i * 150}
            data-sal-duration="1000"
            data-sal-easing="easeOutQuart"
            key={i}
          >
            <AccordionButton {...faq} />
          </div>
        ))}
      </Flex>
    </Container>
  );
};

export default AccordionSection;
